/**
 * The merchant app's Supabase client.
 *
 * A distinct `storageKey` keeps a merchant session separate from any customer
 * session on the same origin.
 *
 * URL session detection is on here and off in the customer app: signing in with
 * an OAuth provider returns the merchant to this app with the session in the URL
 * fragment, and the client has to read it out. The customer app signs in
 * anonymously and never receives one, so it does not pay for the parsing.
 */

import { createAppClient } from '@yummy/db';

export const supabase = createAppClient('yummy.merchant.auth', { detectSessionInUrl: true });
